/**
 * cos 文件工具类
 * @author frankylli
 */
import SparkMD5 from 'spark-md5'
import { audioCheckErrorMap, imageType, trackType, videoType } from '@/utils/constants'

// 根据文件获取上传类型
export function getUploadType(ext) {
  if (trackType.includes(ext)) {
    return 'track'
  } else if (imageType.includes(ext)) {
    return 'image'
  } else if (videoType.includes(ext)) {
    return 'video'
  }

  return 'other'
}

// 计算文件md5
export function getFileMd5(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result)
      const spark = new SparkMD5.ArrayBuffer()
      spark.append(data)
      const md5 = spark.end()
      resolve(md5)
    }

    reader.onerror = reject

    reader.readAsArrayBuffer(file)
  })
}

/**
 * cos 文件路径外包同学不能直接访问, 并且图片/XML等文件不能直接在浏览器打开,必须通过一层代理服务访问
 * @param {String} url cos文件地址
 * @param {Boolean} [forceDownload=false] - 是否强制下载
 */
export function toPreview(url, forceDownload = false) {
  return `/action/upload/cos_preview?url=${encodeURIComponent(url)}&download=${forceDownload ? 1 : 0}`
}

export function isAudioCheckError(checkQuality) {
  const checkList = checkQuality.split(',')
  const errorCodes = Object.keys(audioCheckErrorMap)
  const errorReg = new RegExp(`^(${errorCodes.join('|')})$`, '')

  return checkList.some(code => errorReg.test(code))
}

export async function getFileText(file) {
  const reader = new FileReader()
  reader.readAsText(file, 'utf-8')
  return new Promise((resolve, reject) => {
    reader.onload = function(e) {
      const data = e.target.result
      resolve(data)
    }
    reader.onerror = function(e) {
      reject(e.target.error)
    }
  })
}

export const downloadFile = (url, fileName = '') => {
  const eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  eleLink.href = url
  // 受浏览器安全策略的因素，动态创建的元素必须添加到浏览器后才能实施点击
  document.body.appendChild(eleLink)
  // 触发点击
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}
